// Import model
import { StartLeadQueueEmailCampaignRequest } from '../models/StartLeadQueueEmailCampaignRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartLeadQueueEmailCampaignRequest - handles JSON serialization and deserialization with type validation
 */
export class StartLeadQueueEmailCampaignRequestSerializer {
  /**
   * Deserializes a JSON string into a StartLeadQueueEmailCampaignRequest instance
   */
  static deserialize(json: string): StartLeadQueueEmailCampaignRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartLeadQueueEmailCampaignRequest instance
   */
  static fromObject(obj: any): StartLeadQueueEmailCampaignRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartLeadQueueEmailCampaignRequest');
    }


    const instance: StartLeadQueueEmailCampaignRequest = {
      name: obj['Name'] as string | undefined,
      description: obj['Description'] as string | undefined,
      fromName: obj['FromName'] as string | undefined,
      fromEmail: obj['FromEmail'] as string | undefined,
      subject: obj['Subject'] as string | undefined,
      toNameField: obj['ToNameField'] as string | undefined,
      toEmailField: obj['ToEmailField'] as string | undefined,
      unlayerTemplateId: obj['UnlayerTemplateId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartLeadQueueEmailCampaignRequest instances
   */
  static deserializeArray(json: string): StartLeadQueueEmailCampaignRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartLeadQueueEmailCampaignRequest instance to a JSON string
   */
  static serialize(instance: StartLeadQueueEmailCampaignRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartLeadQueueEmailCampaignRequest instance to a plain object
   */
  static toObject(instance: StartLeadQueueEmailCampaignRequest): any {
    return {
      'Name': instance.name,
      'Description': instance.description,
      'FromName': instance.fromName,
      'FromEmail': instance.fromEmail,
      'Subject': instance.subject,
      'ToNameField': instance.toNameField,
      'ToEmailField': instance.toEmailField,
      'UnlayerTemplateId': instance.unlayerTemplateId,
    };
  }

  /**
   * Serializes an array of StartLeadQueueEmailCampaignRequest instances to a JSON string
   */
  static serializeArray(instances: StartLeadQueueEmailCampaignRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
